export default function Third() {
  return (
    <>
      <g style={{ mixBlendMode: 'hard-light' }}>
        <path
          d="m 233.5895,129.94749 0,-102.033294 L 13.825812,92.91789 c 0,0 -7.4998598,3.5 -1.99993,15.5 5.49993,12 15.00003,6.5 15.00003,6.5 z"
          fill="url(#paint0_linear_527_12)"
          fillOpacity="0.9"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_527_12"
          x1="7.5"
          y1="48"
          x2="162.972"
          y2="-57.0953"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE32B" />
          <stop offset="1" stopColor="#B60C00" />
        </linearGradient>
      </defs>
    </>
  );
}
